import classNames from "classnames";
import { GlutenFreeIdentity as GlutenFreeIdentityType } from "@/constants/gluten-free";
import { GlutenFreeAppliancesList } from "@/components/molecules/GlutenFreeAppliancesList";
import { CircleCheckIcon } from "./CircleCheckIcon";
import { CircleXIcon } from "./CircleXIcon";
import { QuestionMarkIcon } from "./QuestionMarkIcon";
import { CircleQuestionMark } from "./CircleQuestionMark";
import { CheckIcon } from "./CheckIcon";
import { XIcon } from "./XIcon";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

const Icon = {
	mobile: {
		[GlutenFreeIdentityType.UNKNOWN]: QuestionMarkIcon,
		[GlutenFreeIdentityType.NO]: XIcon,
		[GlutenFreeIdentityType.ENABLED]: CheckIcon,
		default: QuestionMarkIcon,
	},
	desktop: {
		[GlutenFreeIdentityType.UNKNOWN]: CircleQuestionMark,
		[GlutenFreeIdentityType.NO]: CircleXIcon,
		[GlutenFreeIdentityType.ENABLED]: CircleCheckIcon,
		default: CircleQuestionMark,
	},
};

const getIcon = (state, isMobile) => {
	const device = isMobile ? "mobile" : "desktop";
	return Icon[device][state] || Icon[device].default;
};

export const GlutenFreeIdentityItem = ({ item, isMobile }) => {
	const Icon = getIcon(item.state, isMobile);
	const isDisabled =
		item.state === GlutenFreeIdentityType.UNKNOWN ||
		item.state === GlutenFreeIdentityType.NO;

	return (
		<div
			className={classNames(inter.className, {
				"flex gap-2 md:gap-1 items-center text-sky-950 h-6": true,
				"text-[15px] pl-2 pr-3 md:pl-0": true,
				"opacity-60": isDisabled,
			})}>
			<Icon size={isMobile ? 16 : 18} />
			<div className="flex justify-center flex-col">
				<h1
					className={classNames(inter.className, {
						"tracking-tight leading-tight md:leading-snug": true,
						"font-semibold": true,
						"text-sky-950": true,
						"text-[13px] md:text-[15px] ": true,
						"mb-1": item.subelements?.length && isMobile,
					})}>
					{item.text}
				</h1>
				<GlutenFreeAppliancesList items={item.subelements} />
			</div>
		</div>
	);
};
